<!-- <template>
  <div id="#mount-point">

    <component :is="Com" :prop="prop" :model="model"></component>
  </div>
</template> -->

<style scoped>

</style>

<script>
  import PropView from "./propView.ts";
  export default PropView;
</script>